import { pageReturn, trackPageVisits } from '../../components/return_button/index.js';

document.addEventListener('DOMContentLoaded', () => {
    pageReturn();
    trackPageVisits();
});
